import { Entity } from './entity';
export class Label extends Entity {
    /** parent is the entity having this label */
    toString() {
        return 'label of ' + (this.parent ? this.parent.toString() : 'null');
    }
    constructor(labelledParent) {
        super();
        this.parent = labelledParent;
    }
}
//# sourceMappingURL=label.js.map